import { entityName } from "./entityName";

const STYLE = `
  #item-context { position: fixed; z-index: 200; background: #fffdf5; border: 2px solid #b9d8aa; border-radius: 14px; padding: 6px 0; min-width: 140px; box-shadow: 0 4px 16px #1d352966; display: none; }
  #item-context.show { display: block; }
  #item-context .ctx-name { padding: 4px 14px 6px; font: 700 14px system-ui, sans-serif; color: #31583b; border-bottom: 1px solid #b9d8aa; margin-bottom: 4px; }
  #item-context .ctx-btn { display: block; width: 100%; text-align: left; background: none; border: none; color: #314338; padding: 6px 14px; font: 14px system-ui, sans-serif; cursor: pointer; border-radius: 0; }
  #item-context .ctx-btn:hover { background: #e7f5db; }
`;

const ACTION_TIPS: Readonly<Record<string, string>> = {
  look: "Read a description (no action taken)",
  inspect: "Reveal an artifact's true identity",
  examine: "Study a discovered artifact more closely",
  take: "Pick up into your backpack",
  drop: "Place on the ground at your feet",
  place: "Set down on a table or shelf",
  open: "Look inside a container",
  wear: "Put on as clothing",
  "wear-from-scene": "Put on directly — no backpack needed",
  remove: "Take off worn clothing",
  rub: "Clean a tarnished surface",
  combine: "Merge with an item from your backpack",
};

export { ACTION_TIPS };

export function createItemContextMenu(): {
  show(
    item: { instanceId: string; definitionId: string },
    actions: readonly { id: string; label: string }[],
    onPick: (id: string) => void,
    anchor: HTMLElement,
  ): void;
} {
  const style = document.createElement("style");
  style.textContent = STYLE;
  document.head.appendChild(style);

  const el = document.createElement("div");
  el.id = "item-context";
  document.body.appendChild(el);

  document.addEventListener("pointerdown", (e) => {
    if (!el.contains(e.target as Node)) el.classList.remove("show");
  });

  return {
    show(item, actions, onPick, anchor) {
      el.innerHTML = "";
      const name = document.createElement("div");
      name.className = "ctx-name";
      name.textContent = entityName(item.definitionId);
      el.appendChild(name);
      for (const action of actions) {
        const btn = document.createElement("button");
        btn.className = "ctx-btn";
        btn.textContent = action.label;
        btn.title = ACTION_TIPS[action.id] ?? action.label;
        btn.onclick = (e) => {
          e.stopPropagation();
          el.classList.remove("show");
          onPick(action.id);
        };
        el.appendChild(btn);
      }
      const rect = anchor.getBoundingClientRect();
      el.style.left = `${rect.left}px`;
      el.style.top = `${rect.top - el.offsetHeight - 4}px`;
      el.classList.add("show");
    },
  };
}
